'use strict';

var PersonalContactInfoCustomValidator = function PersonalContactInfoCustomValidator($resource, $log) {

	return {

		validatePersonalInfo: validatePersonalInfo

	};

	function validatePersonalInfo(emailAddress, domesticCntryCd, intlCntryCode) {

		var phoneNumber = '';
		var intlNumber = '';
		var cntryCode = '';
		var domesticCntryCode = '';
		var phoneNumberWithNoMasking = '';


		var formStatusWithErrorCd = {
			"validForm": true,
			"errorCode": ''
		};


		if ($("#phoneNumberIdD").is(":visible")) {
			phoneNumber = $("#phoneNumberIdD").val();
			var temp = domesticCntryCd;
			domesticCntryCode = domesticCntryCd.substring(0, 2);
			phoneNumberWithNoMasking = phoneNumber.replace("(", "").replace(")", "").replace("-", "").replace(" ", "");

		}
		if ($("#phoneNumberIdI").is(":visible")) // This condition becomes true when the domestic number being changed to INTLNumber
		{
			intlNumber = $("#phoneNumberIdI").val();
			var temp = intlCntryCode
			cntryCode = temp.substring(0, 2);

		}
		// This condition becomes true when the domestic number being changed to INTLNumber
		if ($('#intlNumberIdD').is(':visible') && $('#intlNumberIdD').val() && domesticCntryCd) {
			var temp = domesticCntryCd;
			intlNumber = $('#intlNumberIdD').val();
			cntryCode = temp.substring(0, 2);

		}

		if ($("#phoneNumberIdI").is(":visible")) {
			phoneNumber = $("#phoneNumberIdI").val();
			var temp = intlCntryCode;
			domesticCntryCode = intlCntryCode.substring(0, 2);
			phoneNumberWithNoMasking = phoneNumber.replace("(", "").replace(")", "").replace("-", "").replace(" ", "");

		}
		// This condition becomes true when the domestic number being changed to INTLNumber
		if ($('#intlNumberIdI').is(':visible') && $('#intlNumberIdI').val() && intlCntryCode) {
			var temp = intlCntryCode;
			intlNumber = $('#intlNumberIdI').val();
			cntryCode = temp.substring(0, 2);

		}

		if (intlNumber === '' && (phoneNumber === '' || phoneNumber === '(___) ___-____')) {
			formStatusWithErrorCd = {
				"validForm": false,
				"errorCode": 'both_numbers_empty'

			};
		}

		if ((domesticCntryCode === 'US' && cntryCode === 'US')
			&& ($("#phoneNumberIdD").is(":visible"))
			&& ($("#phoneNumberIdI").is(":visible"))
			&& ($("#phoneNumberIdD").val() != '(___) ___-____')
			&& ($("#phoneNumberIdI").val() != '(___) ___-____')) {
			formStatusWithErrorCd = {
				"validForm": false,
				"errorCode": 'both_numbers_domestic'

			};
		}
		if ((domesticCntryCode != 'US' && cntryCode != 'US')
			&& ($("#intlNumberIdI").is(":visible"))
			&& ($("#intlNumberIdD").is(":visible"))
			&& ($("#intlNumberIdI").val() != '')
			&& ($("#intlNumberIdD").val() != '')) {
			formStatusWithErrorCd = {
				"validForm": false,
				"errorCode": 'both_numbers_INTL'

			};
		}
		if (formStatusWithErrorCd.validForm && (phoneNumberWithNoMasking != '' && phoneNumberWithNoMasking != '__________')) {
			var pattern = /^\d{10}$/;

			formStatusWithErrorCd = {
				"validForm": pattern.test(phoneNumberWithNoMasking),
				"errorCode": ''

			};
		}

		return formStatusWithErrorCd;

	};
}
PersonalContactInfoCustomValidator.$inject = ['$resource', '$log'];
export default PersonalContactInfoCustomValidator;